import {useSelector} from "react-redux";
import {State} from "@App/state";
import {useQuery} from "@apollo/client";
import {GET_VEHICLETREE} from "@App/graphql/queries";
import {ServiceIsInspection} from "@App/utils/conditionals/services";

export const useVehicletree = (showBrands: Boolean = false, showGenerations: Boolean = false) => {

    const brand = useSelector((state: State) => state.orders.brand)
    const generation = useSelector((state: State) => state.orders.generation)
    const organization = useSelector((state: State) => state.orders.organization)

    const service = useSelector((state: State) => state.orders.service)


    const {loading, data, error} = useQuery(GET_VEHICLETREE, {
        variables: {
            ...brand && !showBrands && {brandId: +brand.id}, // use +brand.id to convert string to number
            ...generation && !showGenerations && {generationId: +generation.id}, // use +generation.id to convert string to number
            ...service && !ServiceIsInspection(service) && {hasTimes: true},
            ...service && ServiceIsInspection(service) && {hasMaintenance: true},
            ...organization && {organization: +organization.id},
            includeGenerations: !!brand && !showBrands,
            includeMotorizations: !!generation && !showGenerations,
        },
        skip: showGenerations && !brand

    })

    return {
        loading: loading,
        error: error,
        brands: data ? data.brands : null,
        generations: data && brand ? data.brands[0].generations : null,
        motorizations: data && brand && generation && data.brands[0].generations ? data.brands[0].generations[0].motorizations : null,
    }
}


